import { fetchConfig } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

/**
 * Direct checkout on PDP: add current variant + quantity, then go to /checkout.
 */
function getProductFormComponent() {
  const info = document.querySelector('product-information');
  return info?.querySelector('product-form-component') ?? document.querySelector('product-form-component');
}

/**
 * @param {Element | null | undefined} form
 */
function getVariantAndQuantity(form) {
  const idInput = form?.querySelector('input[name="id"]');
  const variantId = idInput?.value ? Number(idInput.value) : null;
  const qInput = form?.querySelector('input[name="quantity"]');
  const parsed = qInput?.value ? parseInt(String(qInput.value), 10) : 1;
  const quantity = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  return { variantId, quantity };
}

function initDirectCheckout() {
  if (document.documentElement.dataset.productDirectCheckoutBound === 'true') return;
  document.documentElement.dataset.productDirectCheckoutBound = 'true';

  let lastVariantAvailable = true;
  const addBtn = document.querySelector('product-form-component button[name="add"]');
  if (addBtn instanceof HTMLButtonElement) {
    lastVariantAvailable = !addBtn.disabled;
  }

  const syncBuyNowButtons = () => {
    document.querySelectorAll('[data-pdp-buy-now-button], [data-gallery-buy-now-button]').forEach((btn) => {
      if (btn instanceof HTMLButtonElement) {
        btn.disabled = !lastVariantAvailable;
      }
    });
  };

  syncBuyNowButtons();

  document.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const resource = /** @type {{ detail?: { resource?: { available?: boolean } } }} */ (event).detail?.resource;
    if (!resource) return;
    lastVariantAvailable = Boolean(resource.available);
    syncBuyNowButtons();
  });

  document.addEventListener('click', async (e) => {
    const target = /** @type {HTMLElement} */ (e.target);
    const buyBtn = target.closest('[data-pdp-buy-now-button], [data-gallery-buy-now-button]');
    if (!buyBtn || !(buyBtn instanceof HTMLButtonElement) || buyBtn.disabled) return;

    const form = getProductFormComponent();
    if (!form) return;

    const { variantId, quantity } = getVariantAndQuantity(form);
    if (!variantId) return;

    buyBtn.disabled = true;

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        ...fetchConfig('json', {
          body: JSON.stringify({
            items: [{ id: variantId, quantity }],
          }),
        }),
      });

      const data = await response.json();

      if (data.status && data.message) {
        throw new Error(data.message);
      }

      window.location.assign('/checkout');
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      window.alert(message);
      buyBtn.disabled = !lastVariantAvailable;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDirectCheckout, { once: true });
} else {
  initDirectCheckout();
}
